import React from "react";

import Stand from "components/stand";

const StandCommentsPage = ({ standId }) => {
    return <Stand.Comments.Page standId={ standId } />;
};

export default StandCommentsPage;
